import apiClient from '../api';
import i18next from 'i18next';

export const setIsBannerShown = (isBannerShown: boolean | null): void => {
    try {
        if (isBannerShown === null) {
            localStorage.removeItem('isBannerShown');
        }
        isBannerShown
            ? localStorage.setItem('isBannerShown', 'true')
            : localStorage.setItem('isBannerShown', 'false');
    } catch {
        /* ignore */
    }
};
export const getIsBannerShown = (): boolean | null => {
    // try {
    //     return localStorage.getItem('isBannerShown') === 'true'
    //         ? true
    //         : localStorage.getItem('isBannerShown') === 'false'
    //         ? false
    //         : null;
    // } catch {
    //     return null;
    //     /* ignore */
    // }
    return false;
};
export const saveClientSelection = (clientList: ClientsState): void => {
    try {
        if (clientList && apiClient?.session) {
            localStorage.setItem('client-list', JSON.stringify(clientList));
        }
    } catch {
        /* ignore */
    }
};

export const loadClientSelection = (): ClientsState | undefined => {
    try {
        const serializedState = localStorage.getItem('client-list');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (error) {
        return undefined;
    }
};

export const clearLocalStorage = () => {
    try {
        // Do not clear language preference of user on logout
        for (let i = 0; i < localStorage.length - 1; i++) {
            const key = localStorage.key(i);
            if (key && key !== 'i18nextLng' && key !== 'localeId') {
                localStorage.removeItem(key);
            }
        }
    } catch (error) {
        return undefined;
    }
};

export const setSwitchUser = (user?: Record<string, string | number>): void => {
    try {
        if (apiClient?.session && user) {
            const serializedState = JSON.stringify(user);
            localStorage.setItem('switch-user', serializedState);
        } else if (!user) {
            localStorage.removeItem('switch-user');
        }
    } catch {
        /* ignore */
    }
};

export const getSwitchUser = ():
    | Record<string, string | number>
    | undefined => {
    try {
        const serializedState = localStorage.getItem('switch-user');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (error) {
        return undefined;
    }
};

export const setGeneratedReports = (data = []): any => {
    try {
        apiClient?.session &&
            localStorage.setItem('generateReports', JSON.stringify([...data]));
    } catch (error) {
        return undefined;
    }
};

export const getGeneratedReports = () => {
    try {
        const serializedState = localStorage.getItem('generate-reports');
        if (!serializedState) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (e) {
        return undefined;
    }
};

export const storeItem = (key: string, value: any) => {
    try {
        if (apiClient?.session) {
            const serializedState = JSON.stringify(value);
            localStorage.setItem(key, serializedState);
        }
    } catch {
        /* ignore */
    }
};
export const getItem = (key: string) => {
    try {
        if (apiClient?.session) {
            const serializedState = localStorage.getItem(key);
            if (serializedState === null) {
                return undefined;
            }
            return JSON.parse(serializedState);
        }
    } catch {
        /* ignore */
    }
};

export const setChakraDefaultThemeColor = (theme: any) => {
    try {
        if (theme) {
            localStorage.setItem('chakra-ui-color-mode', theme);
        }
    } catch (error) {
        return undefined;
    }
};
export const changei18nLanguage = (language: string) => {
    i18next.changeLanguage(language, (err, t) => {
        if (err) return console.log('切换语言失败:', err);
        localStorage.setItem('localeId', language); // 更新自定义的 localStorage 键值
    });
};
